// extracted by mini-css-extract-plugin
export var label = "index-module--label--1qtxk";
export var root = "index-module--root--kWfUJ";